const shopifyStoreUrl = "https://int-oenling-com.myshopify.com";
const apiPassword = "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";
const apiVersion = "2024-01";

// Function to fetch data with pagination
async function shopifyRequest(url) {
    const headers = {
        "Content-Type": "application/json",
        "X-Shopify-Access-Token": apiPassword
    };

    let response = await fetch(url, { headers });
    let data = await response.json();
    
    let nextPageUrl = null;
    let linkHeader = response.headers.get("Link");
    if (linkHeader) {
        let match = linkHeader.match(/<([^>]+)>; rel="next"/);
        if (match) {
            nextPageUrl = match[1];
        }
    }

    return { data, nextPageUrl };
}

// Fetch all products
async function fetchAllProducts() {
    let products = {};
    let nextPageUrl = `${shopifyStoreUrl}/admin/api/${apiVersion}/products.json?limit=250`;

    while (nextPageUrl) {
        let response = await shopifyRequest(nextPageUrl);
        response.data.products.forEach(product => {
            products[product.id] = product.product_type || "";
        });
        nextPageUrl = response.nextPageUrl;
    }

    return products;
}

// Check if a product is a Yarn product
function isYarnProduct(productId, productCache) {
    return productCache[productId] && productCache[productId].toLowerCase().includes("yarn");
}

// Fetch orders in chunks
async function fetchOrdersInChunks(startDate, endDate) {
    let orders = [];
    let currentStart = new Date(startDate).toISOString();
    let currentEnd = new Date(endDate).toISOString();
    
    let nextPageUrl = `${shopifyStoreUrl}/admin/api/${apiVersion}/orders.json?status=any&limit=250&created_at_min=${currentStart}&created_at_max=${currentEnd}`;

    while (nextPageUrl) {
        let response = await shopifyRequest(nextPageUrl);
        orders = orders.concat(response.data.orders);
        nextPageUrl = response.nextPageUrl;
    }

    return orders;
}

// Function to generate and download CSV file
function generateCSV(orders, productCache) {
    let csvContent = "data:text/csv;charset=utf-8,";
    csvContent += "Order ID,Date Sold,Vendor,Product Title,Variant Title,Variant Size,Bundle Kit Name,Is Bundle,Quantity,Net Amount,Is Yarn\n";

    let yarnTotals = { individually: 0, bundles: 0 };
    let kitOrders = {};

    orders.forEach(order => {
        order.line_items.forEach(item => {
            let productId = item.product_id;
            let isYarn = isYarnProduct(productId, productCache);
            let quantity = item.quantity;
            let vendor = item.vendor || "N/A";
            let variantTitle = item.variant_title || "N/A";
            let variantSize = "N/A";
            let kitName = "N/A";
            let isBundle = false;

            if (item.properties) {
                item.properties.forEach(prop => {
                    if (prop.name.toLowerCase() === "_size") {
                        variantSize = prop.value;
                        isBundle = true;
                    }
                    if (prop.name.toLowerCase() === "kit") {
                        kitName = prop.value;
                    }
                });
            }

            let netAmount = (item.price * quantity) - (item.total_discount || 0);

            // Update summary calculations
            if (isYarn) {
                if (isBundle) {
                    yarnTotals.bundles += quantity;
                } else {
                    yarnTotals.individually += quantity;
                }
            }

            if (kitName !== "N/A") {
                kitOrders[kitName] = kitOrders[kitName] || new Set();
                kitOrders[kitName].add(order.id);
            }

            csvContent += `${order.id},${order.created_at.split("T")[0]},${vendor},${item.title},${variantTitle},${variantSize},${kitName},${isBundle ? "Yes" : "No"},${quantity},${netAmount},${isYarn ? "Yes" : "No"}\n`;
        });
    });

    // Add Summary
    csvContent += "\nSummary\n";
    csvContent += `Total Orders Placed,${orders.length}\n`;
    csvContent += `Total Yarn Sold Individually,${yarnTotals.individually}\n`;
    csvContent += `Total Yarn Sold in Bundles,${yarnTotals.bundles}\n`;

    csvContent += "\nSold Summary For Kits\n";
    for (let kit in kitOrders) {
        csvContent += `${kit},${kitOrders[kit].size}\n`;
    }

    // Create download link
    let encodedUri = encodeURI(csvContent);
    let link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `shopify_orders_${new Date().toISOString().split("T")[0]}.csv`);
    document.body.appendChild(link);
    link.click();
}

// Function to fetch and process data
async function fetchAndProcessData(startDate, endDate) {
    let productCache = await fetchAllProducts();
    let orders = await fetchOrdersInChunks(startDate, endDate);
    generateCSV(orders, productCache);
}

// Attach event listener to the form
document.addEventListener("DOMContentLoaded", () => {
    document.getElementById("shopify-report-form").addEventListener("submit", async (e) => {
        e.preventDefault();
        let startDate = document.getElementById("start_date").value;
        let endDate = document.getElementById("end_date").value;
        
        if (new Date(startDate) > new Date(endDate)) {
            alert("⛔ Error: Start date cannot be later than end date.");
            return;
        }

        await fetchAndProcessData(startDate, endDate);
    });
});
